export function createTrackableLink(
  originalLink: string,
  params: Record<string, string>,
): string {
  try {
    // Parse the original URL
    const url = new URL(originalLink);

    // Get existing search params
    const searchParams = url.searchParams;

    // Add new params while preserving existing ones
    Object.entries(params).forEach(([key, value]) => {
      searchParams.set(key, value);
    });

    // Remove any existing 'ch' param to avoid duplicates
    searchParams.delete('ch');

    // Build the base URL without 'ch'
    const baseUrl = url.origin + url.pathname;
    const queryString = searchParams.toString();

    // Decide the separator for 'ch={{identity_token}}'
    let finalUrl = baseUrl;
    if (queryString) {
      finalUrl += `?${queryString}&ch={{identity_token}}`;
    } else {
      finalUrl += `?ch={{identity_token}}`;
    }
    return finalUrl;
  } catch (e) {
    console.log('Error creating trackable link', e);
    // Return original link if URL is invalid
    return originalLink;
  }
}
